import { useWatch } from 'react-hook-form';
import {
  FeeAmountTypeEnum,
  FeeConditionEnum,
  FeeTypeEnum,
} from 'models/PropertyFees';
import { PropertyFeeFormSchemaType } from './PropertyFeeModal.schema';

const useFormData = () => {
  const {
    type,
    amountType,
    scope: scopeField,
    optional: isOptional,
    tax,
    appliesToHostfully,
    rollsIntoRent,
  } = useWatch<PropertyFeeFormSchemaType>();
  const taxCondition = tax?.conditions as
    | { type?: string; lengthOfStayType?: FeeConditionEnum }
    | undefined;
  const taxConditionType = taxCondition?.type;
  const taxConditionLengthOfStayType = taxCondition?.lengthOfStayType;

  const isTypeFee = type === FeeTypeEnum.CUSTOM;
  const isTypeTax = type === FeeTypeEnum.TAX;
  const isAmountPercentage = amountType === FeeAmountTypeEnum.TAX;
  const isTypeAmount = amountType === FeeAmountTypeEnum.AMOUNT;

  const isAppliedToHostfully = appliesToHostfully === 'YES';
  const isRollInFeeIntoRent = rollsIntoRent === 'YES';

  const scopeValue = isAmountPercentage ? scopeField?.tax : scopeField?.amount;

  return {
    type,
    isTypeFee,
    isTypeTax,
    isAmountPercentage,
    scopeValue,
    taxConditionType,
    taxConditionLengthOfStayType,
    isTypeAmount,
    isOptional,
    isAppliedToHostfully,
    isRollInFeeIntoRent,
  };
};

export default useFormData;
